import { render, staticRenderFns } from "./MessagesForm.vue?vue&type=template&id=60d56966&scoped=true&lang=html"
import script from "./MessagesForm.vue?vue&type=script&lang=js"
export * from "./MessagesForm.vue?vue&type=script&lang=js"
import style0 from "./MessagesForm.vue?vue&type=style&index=0&id=60d56966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d56966",
  null
  
)

export default component.exports